import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

export const INPUT_WIDE_WIDTH = 300;
export const INPUT_NARROW_WIDTH = 70;
export const INPUT_LABEL_WIDTH = 140;
export const ATTENTION_COLOR = '#c41723';

export const ellipsisStyle: NestedCSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export const wideWidth: NestedCSSProperties = {
  width: INPUT_WIDE_WIDTH
};

export const narrowTextFieldStyle = style({
  '$nest': {
    'input': {
      width: INPUT_NARROW_WIDTH
    }
  }
});
export const formError = style({
  color: ATTENTION_COLOR
});

export const disabledText = style({
  color: TabStyles.Typography.Color.Disabled
});

export const settingsRadioButtonItemHeight = style({
  '$nest': {
    '& > label': {
      marginLeft: 0
    },
    '& > label + label': {
      marginTop: 3 * TabStyles.Spacing.SmallSpace
    }
  }
});

export const learnMoreStyle = style({
  paddingLeft: 2 * TabStyles.Spacing.SmallSpace,
  paddingRight: 2 * TabStyles.Spacing.SmallSpace,
});
